module.exports = __webpack_public_path__ + "static/img/ic_connect.1f0c875.png";